import Model from 'flarum/common/Model';
export default class TicketCategory extends Model {
  name = Model.attribute('name');
  slug = Model.attribute('slug');
  description = Model.attribute('description');
  position = Model.attribute('position');
  isActive = Model.attribute('isActive');
}
flarum.reg.add('cengizkemec-support-tickets', 'common/models/TicketCategory', TicketCategory);